<template>
	<div class="layout-form-v2">
		<div class="header">
			<div class="title">
				<svgicon v-if="icon" :name="icon" :fill="false" class="icon"/>
				<h1 v-if="h1">{{ h1 }}</h1>
				<h2 v-if="h2"><span v-if="action">{{ actionTranslated | capitalize }} </span>{{ h2 }}</h2>
			</div>
		</div>
		<div class="body">
			<slot></slot>
		</div>
	</div>
</template>

<script>
import capitalize from '@/utils/capitalize'
export default {
	inject: ['$validator'],
	props: [
		'icon',
		'h1',
		'h2',
		'action'
	],
	computed: {
		actionTranslated () {
			return this.$t(`buttons.general.${this.action}`)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/layouts/LayoutFormV2.vue